import { HoldersChart } from '@/components/charts/holdersChart'
import { Card } from '@/components/common/card'
import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'

interface Props {
  vault: Vault
  className?: string
}

export const OwnersDistribution = ({ vault, className }: Props) => {
  return (
    <Card as="section" className={cn('flex flex-col gap-4', className)}>
      <h4 className="font-medium text-base text-heading-foreground">Owners distribution</h4>
      <div className="mx-auto">
        <HoldersChart vault={vault} />
      </div>
    </Card>
  )
}
